console.log('Using environment.dev.ts (development)');
export const environment = {
    production: false,
    firebase: {
        apiKey: "AIzaSyDOoHkB0K5SLVD9Zjq1fZ_B9e3HxEvMK2k",
        authDomain: "tailonedev.firebaseapp.com",
        projectId: "tailonedev",
        storageBucket: "tailonedev.firebasestorage.app",
        messagingSenderId: "971138866937",
        appId: "1:971138866937:web:124a37934a43ba70c80c28",
        measurementId: "G-ZGNGP9NL7Q"
    },
    googlePlacesKey: 'AIzaSyAlAjUJ0ZfuhwAP3EdjbeYLQ06agG657JU',
    imgIxDomain: 'tailOne-dev',
    imgBucket: 'gs://tail_one_static_dev',
    apiBaseURL: 'us-central1-tailonedev',
    mapBoxToken: 'pk.eyJ1IjoicDN0ZXIxODUiLCJhIjoiY21ja3ZmamZrMDRoOTJqcHBpdDZld25qNSJ9.Ff-L_t2nlfxUr8DLh-ICfA',
    defaults: {
        supportEmail: 'support@tailone.ai',
        defaultAircraftSeats: 6
    },
    stripePublishableKey: 'pk_test_51RqfSpPVmP73nnT5gmgTfU1Sc9Ef2CBrO2UONO69PnPnaLsTUs0AjCOTjYpZZtMPWi12K4wBJaofIeUYdC0ncWxS00EkUeikzR',
    subscriptionPriceId: 'price_1RqfWwPVmP73nnT544AjDITS',
    postHogKey: 'phc_jObqJKUJddoz3BXRi8Rg3tUgUsCHmyGgY1JRWa4WyrU',
    postHogHost: 'https://us.i.posthog.com',
    invitationTokens: ['bT1NUw2552']
};